import { useContext } from "react";
import { GlobalContext } from "../top-level-contexts";

export function useSessionActive(): boolean {
  const ctx = useContext(GlobalContext);

  return ctx.sessionActive;
}
